var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('columns',[_c('column',{staticClass:"is-12"},[_c('u-header',{attrs:{"title":_vm.$t('_.tickets'),"cta":_vm.cta,"cta-disabled":_vm.isStaged},on:{"click":_vm.addTicket}},[_c('tabigation',{attrs:{"slot":"tabs","routes":_vm.routes()},slot:"tabs"})],1),_vm._v(" "),_c('tickets-table',{key:_vm.$_.get(_vm.$route.query, 'TT1'),attrs:{"client-id":_vm.client.id,"row-props":function (ticket) { return ({
          to: {
            name: 'adminClientSupportTicket',
            params: {
              ticketId: ticket.id,
              clientId: ticket.client_id
            }
          }
        }); },"show-staged":true}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }